document.addEventListener('DOMContentLoaded', function () {
  var lists = document.querySelectorAll('[data-faq-list]');

  lists.forEach(function (list) {
    var allowMultiple = list.getAttribute('data-allow-multiple') === 'true';
    var triggers = list.querySelectorAll('[data-faq-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));

        if (!allowMultiple) {
          triggers.forEach(function (otherTrigger) {
            if (otherTrigger !== trigger) {
              var otherPanel = document.getElementById(otherTrigger.getAttribute('aria-controls'));
              otherTrigger.setAttribute('aria-expanded', 'false');
              if (otherPanel) {
                otherPanel.style.height = '0px';
              }
            }
          });
        }

        trigger.setAttribute('aria-expanded', String(!expanded));

        if (!expanded) {
          panel.style.height = panel.scrollHeight + 'px';

          panel.addEventListener('transitionend', function handler() {
            if (trigger.getAttribute('aria-expanded') === 'true') {
              panel.style.height = 'auto';
            }
            panel.removeEventListener('transitionend', handler);
          });
        } else {
          panel.style.height = panel.scrollHeight + 'px';
          requestAnimationFrame(function () {
            panel.style.height = '0px';
          });
        }
      });
    });
  });
});